import Vue from "vue";
import Vuex from "vuex";
// import { spiderStart } from "@/mixins/api";

Vue.use(Vuex);

const savedState = JSON.parse(localStorage.getItem("vuexState")) || {};

export default new Vuex.Store({
  state: {
    isLogged: savedState.isLogged || false,
    userData: savedState.userData || {
      username: undefined,
      id: undefined,
      password: undefined,
      lastLogin: undefined,
      group: undefined
      // check:undefined
    },
    curStatus:undefined,
    curResult:undefined,
    curLeft:undefined,
    timeTaken: undefined,
    resetFlag:false
  },
  mutations: {
    login(state) {
      state.isLogged = true;
      localStorage.setItem("vuexState", JSON.stringify(state));
    },
    setUser(state, payload) {
      state.userData = payload;
      localStorage.setItem("vuexState", JSON.stringify(state));
    },
    setLogged(state, status) {
      state.isLogged = status;
      localStorage.setItem("vuexState", JSON.stringify(state));
    },
    setResetFlag(state, payload){
      state.resetFlag = payload
    },
    logout(state) {
      state.isLogged = false;
      state.userData = {
        username: undefined,
        id: undefined,
        password: undefined,
        lastLogin:undefined,
        group: undefined
        // check: undefined
      };
      localStorage.removeItem("vuexState");
    },
    //currentStatus 표시하기 위해 status로 처리
    setScanStatus(state, payload){
      state.curStatus=payload;
      console.log(payload)
      console.log("scan status");
      console.log(state.curStatus);
      localStorage.setItem("scanStatus", payload);
    },
    //값 제거
    resetScanStatus(state) {
      state.curStatus = 0;
      state.timeTaken = null;
    },
    setCurResult(state, payload){
      state.curResult=payload;
      console.log("state.curResult");
      console.log(state.curResult);
    },
    setTimeTaken(state, payload){
      state.timeTaken = payload;
      console.log(state.timeTaken);
      console.log("state.timeTaken");
      localStorage.setItem("timeTaken", payload);
    },
    setCurLeft(state,payload){
      state.curLeft = payload;
      localStorage.setItem("curLeft", payload);
    }
  },
  actions: {
    logout({ commit }) {
      return new Promise((resolve) => {
        setTimeout(() => {
          commit("logout");
          resolve();
        }, 500);
      });
    },
    // scanStart: async function(_, param){
    //   console.log(param)
    //   const spiderResponse = await spiderStart(param)
    // }
  },
});
